import './polyfill';
// require('./modules/externalLinks');
require('./components/main-nav/header');
require('./components/main-nav/mobile');
require('./components/main-nav/sticky');
require('./components/routingCards');
require('./components/slickSlider');
require('./components/mobileSubnav');
require('./components/stickySidebar');
require('./components/postMeta');
require('./components/jobboard');
require('./components/anchorScroll');
require('./components/gravityForms');
require('./components/filters');
require('./components/passwords');
require('./components/accordions');
require('./components/search');
require('./components/notificationBar');
require('./components/anchor');
require('./members/login');

// Remove bottom margin from last `.oda-block` element on Full Width templates
// Only if `.full-width` is on the element. This removes the space before the footer.
if (document.body.classList.contains('page-template-full-width')) {
	let blocks = document.querySelectorAll('.oda-block');
	if (blocks.length > 0) {
		let lastBlock = blocks[blocks.length - 1];
		if (lastBlock && lastBlock.classList.contains('full-width')) {
			lastBlock.style.marginBottom = 0;
		}
	}
}
